import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PartnerOrderItem } from './partnerOrderReducer';

export interface UnconfiguredByCategory {
  wardpanch: number;
  sarpanch: number;
  panchayat_samiti: number;
  zila_parishad: number;
}

export interface UnconfiguredByChannel {
  creator: number;
  channel_partner: number;
}

export interface UnconfiguredOrderState {
  items: PartnerOrderItem[];
  // Count per category, ignoring the category filter, so every badge stays visible
  byCategory: UnconfiguredByCategory;
  // Count per channel, ignoring the channel filter
  byChannel: UnconfiguredByChannel;
  total: number;
  limit: number;
  offset: number;
  loading: boolean;
  error: string | null;
}

const ZERO_BY_CATEGORY: UnconfiguredByCategory = {
  wardpanch: 0,
  sarpanch: 0,
  panchayat_samiti: 0,
  zila_parishad: 0,
};

const ZERO_BY_CHANNEL: UnconfiguredByChannel = {
  creator: 0,
  channel_partner: 0,
};

const initialState: UnconfiguredOrderState = {
  items: [],
  byCategory: ZERO_BY_CATEGORY,
  byChannel: ZERO_BY_CHANNEL,
  total: 0,
  limit: 25,
  offset: 0,
  loading: false,
  error: null,
};

const unconfiguredOrderSlice = createSlice({
  name: 'unconfiguredOrders',
  initialState,
  reducers: {
    setUnconfiguredOrderLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setUnconfiguredOrderError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setUnconfiguredOrderPage: (
      state,
      action: PayloadAction<{
        items: PartnerOrderItem[];
        byCategory: UnconfiguredByCategory;
        byChannel?: UnconfiguredByChannel;
        total: number;
        limit: number;
        offset: number;
      }>
    ) => {
      const { items, byCategory, byChannel, total, limit, offset } = action.payload;
      state.items = items;
      state.byCategory = byCategory;
      if (byChannel) state.byChannel = byChannel;
      state.total = total;
      state.limit = limit;
      state.offset = offset;
    },
  },
});

export const { setUnconfiguredOrderLoading, setUnconfiguredOrderError, setUnconfiguredOrderPage } =
  unconfiguredOrderSlice.actions;

export default unconfiguredOrderSlice.reducer;
